import WelcomeToSession from '~/pages/default-apps/Home/components/WelcomeToSession'
import {Fragment, useEffect, useState} from "react";
import ServicePlanAPI from '~/api/servicePlanApi';
import {useAssetsImage} from  '~/pages/context/AssetsImageContext';
import api from "~/api/api";

function PlanSubscription(){
    const {getImageUrlById} = useAssetsImage();
    const illustrations = [getImageUrlById(42), getImageUrlById(43), getImageUrlById(44), getImageUrlById(45)]
    const [serviceType, setServiceType] = useState(1);
    const [servicePlans, setServicePlans] = useState([]);
    useEffect(() => {
        ServicePlanAPI.getByServiceType(serviceType)
            .then((res) => {
                setServicePlans(res.data);
            })
            .catch((err) => {
            });
    }, [serviceType]);

    const handleSelectPlan = async (id) => {
        const response = await api.post(`/stripe-payments/create-checkout-session/${id}/${serviceType}`);
        window.location.href = response.data.Url;
    }

    return (
        <Fragment>
            <WelcomeToSession bodyEmphasis={false} screen="Upgrade Plan"/>
            <div className="container-medium mb-5">
                <div className="mt-3">
                    <div className="text-center mb-3">
                        <h3>
                            Free plan with all the basic features.
                        </h3>
                        <h3>
                            Pro plan for advanced users.
                        </h3>
                    </div>
                    <ul className="nav nav-underline fs-9 mb-3 d-flex justify-content-center pb-6" id="nav-tab" role="tablist">
                        <li className="nav-item pe-3" role="presentation">
                            <button className="nav-link active fs-8" id="pills-personal-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-personal" type="button" role="tab"
                                    aria-selected="true"
                                    onClick={() => {
                                        setServiceType(1)
                                    }}
                            >
                                Personal
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link fs-8" id="pills-business-tab" data-bs-toggle="pill"
                                    data-bs-target="#pills-business" type="button" role="tab" aria-controls="pills-business"
                                    aria-selected="false" tabIndex="-1"
                                    onClick={() => {
                                        setServiceType(2)
                                    }}
                            >
                                Business
                            </button>
                        </li>
                    </ul>
                    <div className="row g-7 g-lg-11 mb-7">
                        {
                            servicePlans.map((item, index) => {
                                return (
                                    <div key={index} className="col-12 col-sm-6 col-xxl-3">
                                        <div className="d-flex flex-column justify-content-between h-100">
                                            <div>
                                                {
                                                    illustrations[index] &&
                                                    <img className="mb-4 d-dark-none" src={illustrations[index]} alt="" width="120" height="96"/>
                                                }
                                                <div className="mb-sm-3">
                                                    <h3 className="mb-2">{item.Name}</h3>
                                                    <p className="text-body-secondary mb-0 pe-3">{item.Description}</p>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="d-flex align-items-center mb-4">
                                                    <h3 className="display-5 fw-bolder">${item.Price}</h3>
                                                </div>
                                                <button disabled={true} onClick={() => handleSelectPlan(item.ServicePlanId)} type="button" className="btn btn-bt-primary w-100">Select Plan</button>
                                                <h5 className="mb-3 mt-3">What’s included</h5>
                                                <ul className="list-unstyled">
                                                    <li className='pb-2 fs-8-1'>Time Limit: <strong> {item.DurationValue + ' ' + item.DurationUnit} </strong></li>
                                                    {
                                                        item.TypeId === 2 &&
                                                        <li className='pb-2 fs-8-1'>User Limit: <strong> {item.UserLimit + " Users"} </strong></li>
                                                    }
                                                    {
                                                        item.PlanDescriptionMappings.map((item, index) => {
                                                            let liElement = '';
                                                            if (item.IsApply) {
                                                                liElement = <li className='pb-2 fs-8-1' key={index}>{item.Description}</li>
                                                            } else {
                                                                liElement = <li key={index} className="text-decoration-line-through pb-2 fs-8-1 text-body-quaternary">{item.Description}</li>
                                                            }
                                                            return liElement;
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
export default PlanSubscription;